export const handleFunction = (fn?: Function) => (record: any) =>
  Promise.resolve(fn === undefined ? record : fn(record))
